import { Directive, OnDestroy, EventEmitter } from '@angular/core';
import { NgForm, UntypedFormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: 'form'
})
export class NgFormDirective implements OnDestroy {
  private subscriptionSubmit: Subscription;

  submitInvalido = new EventEmitter(false);
  primerControlInvalido: UntypedFormControl;
  constructor(frm: NgForm) {

    this.subscriptionSubmit = frm.ngSubmit.subscribe(() => {
      this.primerControlInvalido = null;

      Object.getOwnPropertyNames(frm.controls).forEach(nombreControl => {
        const control = frm.controls[nombreControl];
        control.updateValueAndValidity();
        if (control.invalid) {
          if (!control.touched) {
            console.log(nombreControl + 'invalido')
            control.markAsTouched();
          }

          if (!this.primerControlInvalido) {
            this.primerControlInvalido = (control as UntypedFormControl);
            this.submitInvalido.emit();
          }
        }
      });

    });
  }

  ngOnDestroy(): void {
    if (this.subscriptionSubmit) {
      this.subscriptionSubmit.unsubscribe();
    }
  }
}
